import { Button } from 'reactstrap';
import { IntlType } from '../../../../utils/typing';

interface Props {
  intl: IntlType;
  handleClick: () => void;
  disabled: boolean;
}

const CreateUserButton = (props: Props): JSX.Element => {
  const { intl, handleClick, disabled } = props;

  return (
    <Button
      className="submit-button confirm"
      color="primary"
      onClick={handleClick}
      disabled={disabled}
      data-testid="create-user-button"
    >
      {intl.formatMessage({ id: 'createUser' })}
    </Button>
  );
};

export default CreateUserButton;
